export class XTokenModule {
    constructor() {
        this.devNeeds = {
            apiUrl: ``,
            username: '1b6f2d50-a534-426c-90c7-747d60624d60',
            password: 'D4m8Q~f64.xZbHMOhV3Pqh2XIMrWeUMXp5vUyaTk'
        };
        this.uatNeeds = {
            apiUrl: ``,
            username: '70b3dcdf-2bba-455e-b9e9-f938800f95f6',
            password: 'Lwu8Q~CSpsVav9LR3XdPB5O4TIgA0ZtMC6Jf0cHx'
        };
        this.prodNeeds = {
            apiUrl: ``,
            username: '14988c2e-e517-4feb-b3c2-d13a1dfab2c8',
            password: 'wCw8Q~ksvyTmpbyuXGGczL2kxUuAuaGQDlXPgaCu'
        };
    }
    get getDevNeeds() {
        return this.devNeeds;
    }
    get getUatNeeds() {
        return this.uatNeeds;
    }
    get getProdNeeds() {
        return this.prodNeeds;
    }
    set setApiUrl(params) {
        this.devNeeds.apiUrl =
            `${process.env.VUE_APP_BASE_URL_XTOKEN_DEV}?scope=` + params;
        this.uatNeeds.apiUrl =
            `${process.env.VUE_APP_BASE_URL_XTOKEN_UAT}?scope=` + params;
        this.prodNeeds.apiUrl =
            `${process.env.VUE_APP_BASE_URL_XTOKEN_PRD}?scope=` + params;
    }
}
